var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.04H2V19.04H3V4.04004C3 3.48776 3.44772 3.04004 4 3.04004H18C18.5523 3.04004 19 3.48776 19 4.04004V9.04004H21V19.04H22V21.04ZM17 19.04H19V11.04H13V19.04H15V13.04H17V19.04ZM17 9.04004V5.04004H5V19.04H11V9.04004H17ZM7 11.04H9V13.04H7V11.04ZM7 15.04H9V17.04H7V15.04ZM7 7.04004H9V9.04004H7V7.04004Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsIcon);
export default __webpack_public_path__ + "static/media/clients-icon.7b7dfda107a6e6a36943b5baec01229e.svg";
export { ForwardRef as ReactComponent };